import type * as lazyIndex from './lazyIndex';
import { LazyImport, LazyModule } from 'owa-bundling-light';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "MailStore"*/ './lazyIndex'),
    {
        name: 'MailStore',
    }
);

export const lazyInitializeSenderFollowUpProcessing: LazyImport<
    typeof lazyIndex.initializeSenderFollowUpProcessing,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.initializeSenderFollowUpProcessing);

export const lazyGetItemIdFromInternetMessageId: LazyImport<
    typeof lazyIndex.getItemIdFromInternetMessageId,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getItemIdFromInternetMessageId);

export const lazyGetItem: LazyImport<typeof lazyIndex.getItem, typeof lazyModule> = new LazyImport(
    lazyModule,
    m => m.getItem
);

export const lazyFetchNeedsReplyReasonsForConversation: LazyImport<
    typeof lazyIndex.fetchNeedsReplyReasonsForConversation,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.fetchNeedsReplyReasonsForConversation);
